import { storableError } from '../../util/errors';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { get, post, patch } from '../../util/api';

// ================ Action types ================ //

const FETCH_COMPANY_REQUEST = 'app/CompanyDashboardPage/FETCH_COMPANY_REQUEST';
const FETCH_COMPANY_SUCCESS = 'app/CompanyDashboardPage/FETCH_COMPANY_SUCCESS';
const FETCH_COMPANY_ERROR = 'app/CompanyDashboardPage/FETCH_COMPANY_ERROR';

const FETCH_STATS_REQUEST = 'app/CompanyDashboardPage/FETCH_STATS_REQUEST';
const FETCH_STATS_SUCCESS = 'app/CompanyDashboardPage/FETCH_STATS_SUCCESS';
const FETCH_STATS_ERROR = 'app/CompanyDashboardPage/FETCH_STATS_ERROR';

const FETCH_VOUCHERS_REQUEST = 'app/CompanyDashboardPage/FETCH_VOUCHERS_REQUEST';
const FETCH_VOUCHERS_SUCCESS = 'app/CompanyDashboardPage/FETCH_VOUCHERS_SUCCESS';
const FETCH_VOUCHERS_ERROR = 'app/CompanyDashboardPage/FETCH_VOUCHERS_ERROR';

const FETCH_USAGE_REQUEST = 'app/CompanyDashboardPage/FETCH_USAGE_REQUEST';
const FETCH_USAGE_SUCCESS = 'app/CompanyDashboardPage/FETCH_USAGE_SUCCESS';
const FETCH_USAGE_ERROR = 'app/CompanyDashboardPage/FETCH_USAGE_ERROR';

const GENERATE_VOUCHERS_REQUEST = 'app/CompanyDashboardPage/GENERATE_VOUCHERS_REQUEST';
const GENERATE_VOUCHERS_SUCCESS = 'app/CompanyDashboardPage/GENERATE_VOUCHERS_SUCCESS';
const GENERATE_VOUCHERS_ERROR = 'app/CompanyDashboardPage/GENERATE_VOUCHERS_ERROR';

const DISTRIBUTE_REQUEST = 'app/CompanyDashboardPage/DISTRIBUTE_REQUEST';
const DISTRIBUTE_SUCCESS = 'app/CompanyDashboardPage/DISTRIBUTE_SUCCESS';
const DISTRIBUTE_ERROR = 'app/CompanyDashboardPage/DISTRIBUTE_ERROR';
const DISTRIBUTE_RESET = 'app/CompanyDashboardPage/DISTRIBUTE_RESET';

const FETCH_EMPLOYEES_REQUEST = 'app/CompanyDashboardPage/FETCH_EMPLOYEES_REQUEST';
const FETCH_EMPLOYEES_SUCCESS = 'app/CompanyDashboardPage/FETCH_EMPLOYEES_SUCCESS';
const FETCH_EMPLOYEES_ERROR = 'app/CompanyDashboardPage/FETCH_EMPLOYEES_ERROR';

const FETCH_VOUCHER_POOLS_REQUEST = 'app/CompanyDashboardPage/FETCH_VOUCHER_POOLS_REQUEST';
const FETCH_VOUCHER_POOLS_SUCCESS = 'app/CompanyDashboardPage/FETCH_VOUCHER_POOLS_SUCCESS';
const FETCH_VOUCHER_POOLS_ERROR = 'app/CompanyDashboardPage/FETCH_VOUCHER_POOLS_ERROR';

const UPDATE_SETTINGS_REQUEST = 'app/CompanyDashboardPage/UPDATE_SETTINGS_REQUEST';
const UPDATE_SETTINGS_SUCCESS = 'app/CompanyDashboardPage/UPDATE_SETTINGS_SUCCESS';
const UPDATE_SETTINGS_ERROR = 'app/CompanyDashboardPage/UPDATE_SETTINGS_ERROR';

// ================ Reducer ================ //

const initialState = {
  company: null,
  stats: null,
  vouchers: [],
  usage: null,
  fetchCompanyInProgress: false,
  fetchCompanyError: null,
  fetchStatsInProgress: false,
  fetchStatsError: null,
  fetchVouchersInProgress: false,
  fetchVouchersError: null,
  fetchUsageInProgress: false,
  fetchUsageError: null,
  generateInProgress: false,
  generateError: null,
  generateResult: null,
  distributeInProgress: false,
  distributeError: null,
  distributeResult: null,
  employees: [],
  fetchEmployeesInProgress: false,
  fetchEmployeesError: null,
  voucherPools: [],
  fetchVoucherPoolsInProgress: false,
  fetchVoucherPoolsError: null,
  updateSettingsInProgress: false,
  updateSettingsError: null,
  updateSettingsResult: null,
};

export default function companyDashboardPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_COMPANY_REQUEST:
      return { ...state, fetchCompanyInProgress: true, fetchCompanyError: null };
    case FETCH_COMPANY_SUCCESS:
      return { ...state, fetchCompanyInProgress: false, company: payload };
    case FETCH_COMPANY_ERROR:
      return { ...state, fetchCompanyInProgress: false, fetchCompanyError: payload };

    case FETCH_STATS_REQUEST:
      return { ...state, fetchStatsInProgress: true, fetchStatsError: null };
    case FETCH_STATS_SUCCESS:
      return { ...state, fetchStatsInProgress: false, stats: payload };
    case FETCH_STATS_ERROR:
      return { ...state, fetchStatsInProgress: false, fetchStatsError: payload };

    case FETCH_VOUCHERS_REQUEST:
      return { ...state, fetchVouchersInProgress: true, fetchVouchersError: null };
    case FETCH_VOUCHERS_SUCCESS:
      return { ...state, fetchVouchersInProgress: false, vouchers: payload };
    case FETCH_VOUCHERS_ERROR:
      return { ...state, fetchVouchersInProgress: false, fetchVouchersError: payload };

    case FETCH_USAGE_REQUEST:
      return { ...state, fetchUsageInProgress: true, fetchUsageError: null };
    case FETCH_USAGE_SUCCESS:
      return { ...state, fetchUsageInProgress: false, usage: payload };
    case FETCH_USAGE_ERROR:
      return { ...state, fetchUsageInProgress: false, fetchUsageError: payload };

    case GENERATE_VOUCHERS_REQUEST:
      return { ...state, generateInProgress: true, generateError: null, generateResult: null };
    case GENERATE_VOUCHERS_SUCCESS:
      return { ...state, generateInProgress: false, generateResult: payload };
    case GENERATE_VOUCHERS_ERROR:
      return { ...state, generateInProgress: false, generateError: payload };

    case DISTRIBUTE_REQUEST:
      return { ...state, distributeInProgress: true, distributeError: null, distributeResult: null };
    case DISTRIBUTE_SUCCESS:
      return { ...state, distributeInProgress: false, distributeResult: payload };
    case DISTRIBUTE_ERROR:
      return { ...state, distributeInProgress: false, distributeError: payload };
    case DISTRIBUTE_RESET:
      return { ...state, distributeInProgress: false, distributeError: null, distributeResult: null };

    case FETCH_EMPLOYEES_REQUEST:
      return { ...state, fetchEmployeesInProgress: true, fetchEmployeesError: null };
    case FETCH_EMPLOYEES_SUCCESS:
      return { ...state, fetchEmployeesInProgress: false, employees: payload };
    case FETCH_EMPLOYEES_ERROR:
      return { ...state, fetchEmployeesInProgress: false, fetchEmployeesError: payload };

    case FETCH_VOUCHER_POOLS_REQUEST:
      return { ...state, fetchVoucherPoolsInProgress: true, fetchVoucherPoolsError: null };
    case FETCH_VOUCHER_POOLS_SUCCESS:
      return { ...state, fetchVoucherPoolsInProgress: false, voucherPools: payload };
    case FETCH_VOUCHER_POOLS_ERROR:
      return { ...state, fetchVoucherPoolsInProgress: false, fetchVoucherPoolsError: payload };

    case UPDATE_SETTINGS_REQUEST:
      return { ...state, updateSettingsInProgress: true, updateSettingsError: null, updateSettingsResult: null };
    case UPDATE_SETTINGS_SUCCESS:
      // Merge updated fields into company state
      return { ...state, updateSettingsInProgress: false, updateSettingsResult: payload, company: state.company ? { ...state.company, ...payload } : payload };
    case UPDATE_SETTINGS_ERROR:
      return { ...state, updateSettingsInProgress: false, updateSettingsError: payload };

    default:
      return state;
  }
}

// ================ Thunks ================ //

export const fetchCompany = slug => dispatch => {
  dispatch({ type: FETCH_COMPANY_REQUEST });
  return get(`/api/companies/${slug}`)
    .then(response => {
      dispatch({ type: FETCH_COMPANY_SUCCESS, payload: response.data });
      return response;
    })
    .catch(e => {
      dispatch({ type: FETCH_COMPANY_ERROR, payload: storableError(e) });
    });
};

export const fetchStats = slug => dispatch => {
  dispatch({ type: FETCH_STATS_REQUEST });
  return get(`/api/companies/${slug}/stats`)
    .then(response => {
      dispatch({ type: FETCH_STATS_SUCCESS, payload: response.data });
      return response;
    })
    .catch(e => {
      dispatch({ type: FETCH_STATS_ERROR, payload: storableError(e) });
    });
};

export const fetchCompanyVouchers = slug => dispatch => {
  dispatch({ type: FETCH_VOUCHERS_REQUEST });
  return get(`/api/companies/${slug}/vouchers`)
    .then(response => {
      dispatch({ type: FETCH_VOUCHERS_SUCCESS, payload: response.data });
      return response;
    })
    .catch(e => {
      dispatch({ type: FETCH_VOUCHERS_ERROR, payload: storableError(e) });
    });
};

export const fetchUsage = slug => dispatch => {
  dispatch({ type: FETCH_USAGE_REQUEST });
  return get(`/api/companies/${slug}/usage`)
    .then(response => {
      dispatch({ type: FETCH_USAGE_SUCCESS, payload: response.data });
      return response;
    })
    .catch(e => {
      dispatch({ type: FETCH_USAGE_ERROR, payload: storableError(e) });
    });
};

export const generateVouchers = (slug, data) => dispatch => {
  dispatch({ type: GENERATE_VOUCHERS_REQUEST });
  return post(`/api/companies/${slug}/vouchers/generate`, data)
    .then(response => {
      dispatch({ type: GENERATE_VOUCHERS_SUCCESS, payload: response.data });
      // Refresh voucher list
      dispatch(fetchCompanyVouchers(slug));
      dispatch(fetchStats(slug));
      return response;
    })
    .catch(e => {
      dispatch({ type: GENERATE_VOUCHERS_ERROR, payload: storableError(e) });
      throw e;
    });
};

export const distributeCredits = (slug, data) => dispatch => {
  dispatch({ type: DISTRIBUTE_REQUEST });
  return post(`/api/companies/${slug}/distribute`, data)
    .then(response => {
      dispatch({ type: DISTRIBUTE_SUCCESS, payload: response.data });
      // Refresh pools, voucher list, stats, and employees
      dispatch(fetchVoucherPools(slug));
      dispatch(fetchCompanyVouchers(slug));
      dispatch(fetchStats(slug));
      dispatch(fetchCompanyEmployees(slug));
      return response;
    })
    .catch(e => {
      dispatch({ type: DISTRIBUTE_ERROR, payload: storableError(e) });
      throw e;
    });
};

export const resetDistribute = () => ({ type: DISTRIBUTE_RESET });

export const fetchCompanyEmployees = slug => dispatch => {
  dispatch({ type: FETCH_EMPLOYEES_REQUEST });
  return get(`/api/companies/${slug}/employees`)
    .then(response => {
      dispatch({ type: FETCH_EMPLOYEES_SUCCESS, payload: response.data });
      return response;
    })
    .catch(e => {
      dispatch({ type: FETCH_EMPLOYEES_ERROR, payload: storableError(e) });
    });
};

export const fetchVoucherPools = slug => dispatch => {
  dispatch({ type: FETCH_VOUCHER_POOLS_REQUEST });
  return get(`/api/companies/${slug}/voucher-pools`)
    .then(response => {
      dispatch({ type: FETCH_VOUCHER_POOLS_SUCCESS, payload: response.data });
      return response;
    })
    .catch(e => {
      dispatch({ type: FETCH_VOUCHER_POOLS_ERROR, payload: storableError(e) });
    });
};

export const resendEmployeeInvite = (slug, employeeId) => dispatch => {
  return post(`/api/companies/${slug}/employees/${employeeId}/resend`)
    .then(() => dispatch(fetchCompanyEmployees(slug)))
    .catch(e => { throw e; });
};

export const revokeEmployeeVoucher = (slug, employeeId) => dispatch => {
  return post(`/api/companies/${slug}/employees/${employeeId}/revoke`)
    .then(() => {
      dispatch(fetchCompanyEmployees(slug));
      dispatch(fetchCompanyVouchers(slug));
      dispatch(fetchStats(slug));
    })
    .catch(e => { throw e; });
};

export const exportCsv = slug => () => {
  // Open export URL in new tab (browser handles download)
  window.open(`/api/companies/${slug}/export`, '_blank');
};

export const updateSettings = (slug, data) => dispatch => {
  dispatch({ type: UPDATE_SETTINGS_REQUEST });
  return patch(`/api/companies/${slug}/settings`, data)
    .then(response => {
      dispatch({ type: UPDATE_SETTINGS_SUCCESS, payload: response.data });
      return response;
    })
    .catch(e => {
      dispatch({ type: UPDATE_SETTINGS_ERROR, payload: storableError(e) });
      throw e;
    });
};

export const loadData = params => dispatch => {
  const { slug } = params;
  return Promise.all([
    dispatch(fetchCurrentUser()),
    dispatch(fetchCompany(slug)),
    dispatch(fetchStats(slug)),
    dispatch(fetchCompanyVouchers(slug)),
    dispatch(fetchUsage(slug)),
    dispatch(fetchCompanyEmployees(slug)),
    dispatch(fetchVoucherPools(slug)),
  ]);
};
